import { TextFieldEntry, SelectEntry } from '@bpmn-io/properties-panel'
import { useService } from 'bpmn-js-properties-panel'
import { getRoles } from '../util'
import { useState } from '@bpmn-io/properties-panel/preact/hooks'

const EMPTY_OPTION = ''

export default function RoleProps(props) {
  const { idPrefix, role } = props

  const entries = [
    {
      id: idPrefix + '-role',
      component: RoleEntry,
      idPrefix,
      role,
    },
    {
      id: idPrefix + '-stakeholder',
      component: StakeholderEntry,
      idPrefix,
      role,
    },
  ]

  return entries
}

function StakeholderEntry(props) {
  const { idPrefix, element, role } = props

  const commandStack = useService('commandStack')
  const debounce = useService('debounceInput')

  const setValue = (value) => {
    commandStack.execute('element.updateModdleProperties', {
      element,
      moddleElement: role,
      properties: {
        stakeholder: value,
      },
    })
  }

  const getValue = (role) => {
    return role.stakeholder
  }

  return TextFieldEntry({
    element: role,
    id: idPrefix + '-stakeholder',
    label: 'Stakeholder',
    getValue,
    setValue,
    debounce,
  })
}

function RoleEntry(props) {
  const { idPrefix, element, role } = props

  const commandStack = useService('commandStack')

  const [disabled, setDisabled] = useState(false)

  const getValue = () => {
    return role.get('role') ?? EMPTY_OPTION
  }

  const setValue = (value) => {
    commandStack.execute('element.updateModdleProperties', {
      element,
      moddleElement: role,
      properties: {
        role: value,
      },
    })
  }

  const getOptions = (roleElement) => {
    const roles = getRoles(element)
    const currentRole = roleElement.get('role')

    const options = [{ value: EMPTY_OPTION, label: '<none>' }]

    if (currentRole == 'Accountable') {
      setDisabled(true)
      options.push({ value: 'Accountable', label: 'Accountable' })
    }
    if (currentRole == 'Responsible') {
      const numberOfResponsible = roles.filter((r) => r.role === 'Responsible').length
      if (numberOfResponsible > 1) {
        setDisabled(false)

        options.push(
          { value: 'Responsible', label: 'Responsible' },
          { value: 'Consulted', label: 'Consulted' },
          { value: 'Informed', label: 'Informed' },
        )
      } else {
        setDisabled(true)
        options.push({ value: 'Responsible', label: 'Responsible' })
      }
    }
    if (currentRole == 'Consulted' || currentRole == 'Informed') {
      setDisabled(false)
      options.push(
        { value: 'Responsible', label: 'Responsible' },
        { value: 'Consulted', label: 'Consulted' },
        { value: 'Informed', label: 'Informed' },
      )
    }
    if (currentRole == EMPTY_OPTION || !currentRole) {
      setDisabled(false)
      if (roles.filter((r) => r.role === 'Accountable').length == 0)
        options.push({ value: 'Accountable', label: 'Accountable' })
      options.push(
        { value: 'Responsible', label: 'Responsible' },
        { value: 'Consulted', label: 'Consulted' },
        { value: 'Informed', label: 'Informed' },
      )
    }

    return options
  }

  return SelectEntry({
    element: role,
    id: idPrefix + '-role',
    label: 'Role',
    getValue,
    setValue,
    getOptions,
    disabled: disabled,
  })
}
